var map = {
	"./404": [
		54,
		7
	],
	"./404/": [
		54,
		7
	],
	"./404/index": [
		54,
		7
	],
	"./404/index.tsx": [
		54,
		7
	],
	"./ComingSoon": [
		55,
		9
	],
	"./ComingSoon/": [
		55,
		9
	],
	"./ComingSoon/index": [
		55,
		9
	],
	"./ComingSoon/index.tsx": [
		55,
		9
	],
	"./Faqs": [
		56,
		10
	],
	"./Faqs/": [
		56,
		10
	],
	"./Faqs/index": [
		56,
		10
	],
	"./Faqs/index.tsx": [
		56,
		10
	],
	"./Galery": [
		57,
		12
	],
	"./Galery/": [
		57,
		12
	],
	"./Galery/index": [
		57,
		12
	],
	"./Galery/index.tsx": [
		57,
		12
	],
	"./Galery/styles": [
		95,
		0,
		20
	],
	"./Galery/styles.ts": [
		95,
		0,
		20
	],
	"./GaleryDescription": [
		58,
		11
	],
	"./GaleryDescription/": [
		58,
		11
	],
	"./GaleryDescription/index": [
		58,
		11
	],
	"./GaleryDescription/index.tsx": [
		58,
		11
	],
	"./Home": [
		59,
		8
	],
	"./Home/": [
		59,
		8
	],
	"./Home/index": [
		59,
		8
	],
	"./Home/index.tsx": [
		59,
		8
	],
	"./Myfarmily": [
		60,
		13
	],
	"./Myfarmily/": [
		60,
		13
	],
	"./Myfarmily/index": [
		60,
		13
	],
	"./Myfarmily/index.tsx": [
		60,
		13
	],
	"./PresaleMinting": [
		61,
		14
	],
	"./PresaleMinting/": [
		61,
		14
	],
	"./PresaleMinting/index": [
		61,
		14
	],
	"./PresaleMinting/index.tsx": [
		61,
		14
	],
	"./Setting": [
		62,
		15
	],
	"./Setting/": [
		62,
		15
	],
	"./Setting/index": [
		62,
		15
	],
	"./Setting/index.tsx": [
		62,
		15
	],
	"./TermsConditions": [
		63,
		16
	],
	"./TermsConditions/": [
		63,
		16
	],
	"./TermsConditions/index": [
		63,
		16
	],
	"./TermsConditions/index.tsx": [
		63,
		16
	],
	"./Welcome": [
		64,
		17
	],
	"./Welcome/": [
		64,
		17
	],
	"./Welcome/index": [
		64,
		17
	],
	"./Welcome/index.tsx": [
		64,
		17
	],
	"./Welcome/styles": [
		96,
		21
	],
	"./Welcome/styles.ts": [
		96,
		21
	],
	"./WhiteListMinting": [
		65,
		18
	],
	"./WhiteListMinting/": [
		65,
		18
	],
	"./WhiteListMinting/index": [
		65,
		18
	],
	"./WhiteListMinting/index.tsx": [
		65,
		18
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 108;
module.exports = webpackAsyncContext;